import {useQuery} from "react-query";
import queryKeys from "./queryKeys";
import getPromise from "./getPromise";

const prefix_url = "/undertaker";

export const useAllUndertakers = ()=>{
    return useQuery(queryKeys.UNDERTAKER_ALL, () => getPromise(prefix_url));
}
